import { Utenti } from 'src/app/Admin/models/utenti';
import { Files } from './../../shared/models/File';
import { ClassicType } from './../../shared/models/ClassicType';
import { Attivita } from './Attivita';
import { Sede } from './Sede';
export class Azienda {
  id: number;
  nominativo: string;
  indirizzo: string;
  tipi: string [];
  tipiObject: ClassicType[];
  ruoli: any[];
  ruoliObject: ClassicType[];
  tipiSedeObject: ClassicType[];
  tipiSede: number[];
  cap: string;
  citta: string;
  provincia: string;
  email: string;
  pec: string;
  telefono: string;
  codice_univoco: string;
  piva: string;
  cf: string;
  note: string;
  commerciale: Utenti;
  id_commerciale: number;
  segnalatoreInterno: Utenti;
  id_segnalatore_interno: number;
  segnalatore: Azienda;
  id_segnalatore: number;
  username: string;
  password: string;
  attivita: Attivita[];
  files: Files;
  sedi: Sede[];
  lat: number;
  lon: number;
  modifica: boolean;
  country: any;
  nazioneObject: ClassicType;
}
